module.exports = "/_next/static/resources/single-22a61bb874584a521c149c5e8327a130.webp";